export const mapBenefitLookupCodes = (
  lookupCodes: string[]
): Record<string, null> =>
  lookupCodes.reduce(
    (previous, current) => ({ ...previous, [current]: null }),
    {}
  );
